import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'featured' | 'compact';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="group flex gap-4 p-3 rounded-lg hover:bg-background-200/60 transition-colors duration-200"
      >
        <div className="w-24 h-16 flex-shrink-0 rounded-md overflow-hidden">
          <img
            src={article.imageUrlCompact}
            alt={article.title}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
            {article.title}
          </h3>
          <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
            <span>{article.date}</span>
            <span>{article.readTime}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.id}`}
      className={`group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 ${
        variant === 'featured' ? 'lg:grid lg:grid-cols-2' : ''
      }`}
    >
      <div className={`overflow-hidden ${variant === 'featured' ? 'aspect-[4/3] lg:aspect-auto' : 'aspect-[3/2]'}`}>
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className={`p-5 ${variant === 'featured' ? 'lg:p-8 lg:flex lg:flex-col lg:justify-center' : ''}`}>
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs font-medium text-primary-600 bg-primary-100/70 px-2.5 py-1 rounded-full">
            {article.category === 'character-background' ? '角色背景' :
             article.category === 'skill-system' ? '技能体系' :
             article.category === 'combo-guide' ? '连招攻略' :
             article.category === 'cultural-impact' ? '文化影响' : '角色排行'}
          </span>
          <span className="text-xs text-foreground-500">{article.readTime}</span>
        </div>
        <h3 className={`font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 ${
          variant === 'featured' ? 'text-xl lg:text-2xl' : 'text-lg'
        }`}>
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-2 mt-4 pt-4 border-t border-background-200/70">
          <span className="text-xs text-foreground-500">{article.author}</span>
          <span className="text-foreground-300">·</span>
          <span className="text-xs text-foreground-500">{article.date}</span>
        </div>
      </div>
    </Link>
  );
}